const supportsTypedArrays = typeof Float32Array === "function";

let allocate;

if (supportsTypedArrays)
{
    allocate = (n) => {
        return new Float32Array(n);
    }
}
else
{
    allocate = (n) => { return new Array(n); }
}

export default allocate;





// WEBPACK FOOTER //
// ./src/util/allocate.js